const createWidgetFactory = require('components-framework/widget/create_widget_factory');

module.exports = createWidgetFactory({
    name: 'membership_remember_me_description',
    viewClass: require('./view'),
});
